// MQTT Topic List

// ************************************
// Batches
export const BATCHES        = 'BATCHES';
export const CREATE_BATCH   = 'CREATE_BATCH';
export const DELETE_BATCH   = 'DELETE_BATCH';
export const UPDATE_BATCH   = 'UPDATE_BATCH';
export const UPDATE_BATCHES = 'UPDATE_BATCHES';

// ************************************
// Bins
export const BINS        = 'BINS';
export const UPDATE_BIN  = 'UPDATE_BIN';
export const UPDATE_BINS = 'UPDATE_BINS';

// ************************************
// Dies
export const DIES = 'DIES';
export const CREATE_DIE = 'CREATE_DIE';
export const DELETE_DIE = 'DELETE_DIE';
export const UPDATE_DIE = 'UPDATE_DIE';

// ************************************
// EOD
export const EOD        = 'EOD';
export const CREATE_EOD = 'CREATE_EOD';
export const DELETE_EOD = 'DELETE_EOD';
export const UPDATE_EOD = 'UPDATE_EOD';

// ************************************
// Horizons
export const HORIZONS = 'HORIZONS';
export const CREATE_HORIZON = 'CREATE_HORIZON';
export const DELETE_HORIZON = 'DELETE_HORIZON';
export const UPDATE_HORIZON = 'UPDATE_HORIZON';

// ************************************
// Horizon Stats
export const HORIZON_STATS = 'HORIZON_STATS';
export const CREATE_HORIZON_STAT = 'CREATE_HORIZON_STAT';
export const DELETE_HORIZON_STAT = 'DELETE_HORIZON_STAT';
export const UPDATE_HORIZON_STAT = 'UPDATE_HORIZON_STAT';

// ************************************
// Jobs
export const JOBS        = 'JOBS';
export const CREATE_JOB  = 'CREATE_JOB';
export const DELETE_JOB  = 'DELETE_JOB';
export const UPDATE_JOB  = 'UPDATE_JOB';
export const UPDATE_JOBS = 'UPDATE_JOBS';

// ************************************
// Orders
export const ORDERS        = 'ORDERS';
export const CREATE_ORDER  = 'CREATE_ORDER';
export const DELETE_ORDER  = 'DELETE_ORDER';
export const UPDATE_ORDER  = 'UPDATE_ORDER';
export const UPDATE_ORDERS = 'UPDATE_ORDERS';

// ************************************
// Products
export const PRODUCTS        = 'PRODUCTS';
export const CREATE_PRODUCT  = 'CREATE_PRODUCT';
export const DELETE_PRODUCT  = 'DELETE_PRODUCT';
export const UPDATE_PRODUCT  = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS';

// ************************************
// Scraps
export const SCRAPS = 'SCRAPS';
export const CREATE_SCRAP = 'CREATE_SCRAP';
export const DELETE_SCRAP = 'DELETE_SCRAP';
export const UPDATE_SCRAP = 'UPDATE_SCRAP';

// ************************************
// Settings
export const SETTINGS       = 'SETTINGS';
export const CREATE_SETTING = 'CREATE_SETTING';
export const DELETE_SETTING = 'DELETE_SETTING';
export const UPDATE_SETTING = 'UPDATE_SETTING';

// ************************************
// Shipments
export const SHIPMENTS        = 'SHIPMENTS';
export const CREATE_SHIPMENT  = 'CREATE_SHIPMENT';
export const DELETE_SHIPMENT  = 'DELETE_SHIPMENT';
export const UPDATE_SHIPMENT  = 'UPDATE_SHIPMENT';
export const UPDATE_SHIPMENTS = 'UPDATE_SHIPMENTS';

// ************************************
// Subassemblies
export const SUBASSEMBLIES      = 'SUBASSEMBLIES';
export const CREATE_SUBASSEMBLY = 'CREATE_SUBASSEMBLY';
export const DELETE_SUBASSEMBLY = 'DELETE_SUBASSEMBLY';
export const UPDATE_SUBASSEMBLY = 'UPDATE_SUBASSEMBLY';

// ************************************
// Templates
export const TEMPLATES       = 'TEMPLATES';
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';

// ************************************
// Users
export const USERS       = 'USERS';
export const CREATE_USER = 'CREATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';

// ************************************
// Yellow Bags
export const YELLOWBAGS       = 'YELLOWBAGS';
export const CREATE_YELLOWBAG = 'CREATE_YELLOWBAG';
export const DELETE_YELLOWBAG = 'DELETE_YELLOWBAG';
export const UPDATE_YELLOWBAG = 'UPDATE_YELLOWBAG';

// ************************************
// Job Locations
export const JOB_LOCATIONS       = 'JOB_LOCATIONS';
export const CREATE_JOB_LOCATION = 'CREATE_JOB_LOCATION';


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/mqtt-topics.ts